export default __webpack_public_path__ + "ef0dc53df3c9d5828d26915e86166865.svg";